import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, ShoppingCart } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useCart } from '@/lib/cart';

export default function CheckoutCancelPage() {
  const { cart, openCart } = useCart();

  return (
    <div className="container mx-auto py-12">
      <div className="max-w-2xl mx-auto">
        <Card className="border-orange-200 bg-orange-50">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <XCircle className="h-16 w-16 text-orange-600" />
            </div>
            <CardTitle className="text-2xl text-orange-800">
              Payment Cancelled
            </CardTitle>
            <p className="text-orange-700 mt-2">
              Your payment was cancelled. No charges were made to your account.
            </p>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="bg-white rounded-lg p-4">
              <h3 className="font-semibold text-lg mb-3">Your Cart is Still Available</h3>
              <p className="text-sm text-muted-foreground mb-4">
                Don't worry! Your {cart.itemCount} item{cart.itemCount !== 1 ? 's' : ''} are still in your cart.
                You can continue shopping or try checking out again.
              </p>
              <div className="flex justify-between items-center">
                <span className="font-medium">Cart Total:</span>
                <span className="font-semibold text-lg">
                  ${cart.totalPrice.toFixed(2)}
                </span>
              </div>
            </div>

            <div className="bg-blue-50 rounded-lg p-4">
              <h3 className="font-semibold text-blue-800 mb-3">What would you like to do?</h3>
              <div className="space-y-2 text-sm text-blue-700">
                <div className="flex items-center gap-2">
                  <ShoppingCart className="h-4 w-4" />
                  <span>Review your cart and try again</span>
                </div>
                <div className="flex items-center gap-2">
                  <ArrowLeft className="h-4 w-4" />
                  <span>Continue shopping for more options</span>
                </div>
              </div>
            </div>

            <div className="flex gap-3">
              <Button 
                onClick={openCart}
                className="flex-1"
              >
                <ShoppingCart className="h-4 w-4 mr-2" />
                View Cart
              </Button>
              <Button asChild variant="outline" className="flex-1">
                <Link to="/checkout">
                  Try Again
                </Link>
              </Button>
            </div>

            <div className="flex gap-3">
              <Button asChild variant="ghost" className="flex-1">
                <Link to="/">
                  Continue Shopping
                </Link>
              </Button>
              <Button asChild variant="ghost" className="flex-1">
                <Link to="/">
                  Return Home
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
